module.exports = __webpack_public_path__ + "static/media/github-original.4097a5be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github-original.svg
// module id = 14
// module chunks = 0